"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertApiEndpointHttpStatusCodeToInvocationStatus = void 0;
const tagValues_1 = require("../tagValues");
const convertApiEndpointHttpStatusCodeToInvocationStatus = (apiEndpointStatus) => {
    const status = apiEndpointStatus.toString();
    if (status.startsWith("2")) {
        return tagValues_1.TagValue.STATUS_SUCCESS;
    }
    return tagValues_1.TagValue.STATUS_FAILURE;
};
exports.convertApiEndpointHttpStatusCodeToInvocationStatus = convertApiEndpointHttpStatusCodeToInvocationStatus;
//# sourceMappingURL=convertApiEndpointHttpStatusCodeToInvocationStatus.js.map